import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgNotificationsStayUpdated(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M56 26.5C56 32.299 51.299 37 45.5 37S35 32.299 35 26.5 39.701 16 45.5 16 56 20.701 56 26.5Z"
        fill="#78B441"
      />
      <path
        d="M88.384 73.088 31.297 88.384 23.648 59.84c-4.224-15.764 5.131-31.968 20.896-36.192 15.764-4.224 31.968 5.131 36.192 20.896l7.648 28.544Z"
        fill="#78B441"
      />
      <path
        d="M89 72.878 31.695 88l-7.677-28.218c-4.24-15.585 5.15-31.603 20.975-35.78 15.824-4.175 32.09 5.073 36.33 20.658L89 72.878Z"
        fill="#78B441"
      />
      <path
        d="M89 72.878 31.695 88l-7.677-28.218c-4.24-15.585 5.15-31.603 20.975-35.78 15.824-4.175 32.09 5.073 36.33 20.658L89 72.878Z"
        fill="#78B441"
      />
      <path
        d="M57.23 30.781a.8.8 0 0 1 .989-.55c2.22.632 4.331 1.694 6.259 3.126a.801.801 0 0 1-.955 1.286c-1.783-1.325-3.72-2.297-5.742-2.873a.8.8 0 0 1-.55-.989Z"
        fill="#fff"
      />
      <path
        d="M51.957 22.201a.8.8 0 0 1 .086 1.598 32.218 32.218 0 0 0-13.66 3.903.8.8 0 0 1-.767-1.404A33.816 33.816 0 0 1 51.957 22.2Z"
        fill="#0F172A"
      />
      <path
        d="m48 66.343-1.215-2.099c-9.721-.124-18.297-6.52-21.36-15.932L24.02 44a30.118 30.118 0 0 0-.744 11.845L28.682 77 48 66.343Z"
        fill="#599F40"
      />
      <path
        d="M88.406 73.348c1.408 5.255-10.23 12.94-25.994 17.163-15.764 4.224-29.685 3.389-31.093-1.866-1.408-5.255 10.23-12.939 25.994-17.163s29.685-3.388 31.093 1.866Z"
        fill="#0F172A"
      />
      <path
        d="M55 82.5c0 4.142-3.582 7.5-8 7.5s-8-3.358-8-7.5c0-4.142 3.582-7.5 8-7.5s8 3.358 8 7.5Z"
        fill="#599F40"
      />
      <path
        d="M89 31.5c0 5.247-4.701 9.5-10.5 9.5S68 36.747 68 31.5 72.701 22 78.5 22 89 26.253 89 31.5Z"
        fill="#FC0"
      />
      <path
        d="M82.2 32a4.2 4.2 0 0 0-4.2-4.2.8.8 0 1 1 0-1.6 5.8 5.8 0 0 1 5.8 5.8.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M44.333 75.21C41.226 76.198 39 78.865 39 82c0 0 1.6-2.4 8-2.4s8 2.4 8 2.4c0-3.135-2.226-5.802-5.333-6.79V70h-5.334v5.21Z"
        fill="#007A5F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.276 90.537c-5.803 3.831-13.694 7.18-22.314 9.489-8.62 2.31-17.128 3.356-24.07 2.939-3.417-.205-7.032-.795-10.225-2.167-3.063-1.315-7.395-4.125-8.863-9.604-1.468-5.478.879-10.078 2.874-12.748 2.08-2.784 4.914-5.103 7.77-6.99 5.805-3.831 13.696-7.179 22.316-9.489 8.62-2.31 17.127-3.356 24.07-2.939 3.417.205 7.031.796 10.224 2.167 3.063 1.315 7.395 4.125 8.863 9.604 1.468 5.478-.879 10.078-2.874 12.749-2.079 2.784-4.914 5.102-7.77 6.989Zm-24.864-.026c15.764-4.224 27.402-11.908 25.994-17.163-1.407-5.254-15.329-6.09-31.093-1.866S29.911 83.39 31.32 88.645c1.408 5.255 15.329 6.09 31.093 1.866Z"
        fill="#78B441"
      />
      <path
        d="M40.82 66.023a.8.8 0 0 1 .654 1.46c-3.19 1.43-6.088 2.993-8.584 4.641a.8.8 0 1 1-.882-1.335c2.58-1.703 5.557-3.307 8.812-4.766Zm13.737-4.828c8.68-2.326 17.276-3.389 24.325-2.965a.8.8 0 1 1-.097 1.597c-6.835-.41-15.254.62-23.814 2.913a95.132 95.132 0 0 0-8.619 2.747.8.8 0 1 1-.56-1.499 96.733 96.733 0 0 1 8.765-2.793Z"
        fill="#0F172A"
      />
      <path
        d="M65.359 99.93c8.547-2.342 16.371-5.736 22.126-9.62 1.551-1.048 3.096-2.227 4.515-3.542L88.633 73c1.203 5.324-10.283 13.032-25.802 17.284-12.7 3.48-24.194 3.572-28.807.628a6.078 6.078 0 0 1-.84-.64c-.596-.547-.999-1.174-1.184-1.88l3.335 13.639c2.035.49 4.131.754 6.157.878 6.884.423 15.32-.638 23.867-2.98Z"
        fill="#599F40"
      />
    </svg>
  )
}
export default wrapIllustration(SvgNotificationsStayUpdated)
